require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./photos-professional-pm-4-xd.json") })
        }
      }, "path---photos-professional-pm-4-xd");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---photos-professional-pm-4-xd!./.cache/json/photos-professional-pm-4-xd.json
// module id = 866
// module chunks = 231608221292675